import { render, staticRenderFns } from "./UCLayoutTwoColumn.vue?vue&type=template&id=4bcb83b1&scoped=true&"
import script from "./UCLayoutTwoColumn.vue?vue&type=script&lang=ts&"
export * from "./UCLayoutTwoColumn.vue?vue&type=script&lang=ts&"
import style0 from "./UCLayoutTwoColumn.vue?vue&type=style&index=0&id=4bcb83b1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcb83b1",
  null
  
)

export default component.exports